import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Assignee, FacilityType, ProductType } from '../../models/CommonModels';
import { AlertService } from '../../shared/services/alert.service';
import { CommonService } from '../../shared/services/common.service';
import { InspectionService } from '../shared/services/inspection.service';
import {NgForm} from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserDto } from '../../models/User';
import { UserService } from '../../services/user.service';
import { AccountService } from '../../services/account.service';
import * as Constants from '../../models/Constants';
import { Inspection, InspectionAssignment, InspectionFacility, InvestigationType, 
  InspectionTypes as ITPS,
  InspectionReason} from '../shared/models/Inspection';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: 'app-create-inspection',
  templateUrl: './create-inspection.component.html',
  styleUrls: ['./create-inspection.component.css']
})
export class CreateInspectionComponent implements OnInit {

  @ViewChild('assignForm') assignForm: NgForm;
  public tabList: Array <string> = ['facility', 'inspectors'];
  public tab: string;
  public tabIndex: number = 0;
  public selectedFacilityTypeId: number;
  public selectedProductTypeId: number;
  public productTypes : Array<ProductType> = [];
  public facilityTypes : Array<FacilityType> = [];
  public facilities : Array<any> = [];
  public selectedFacilityId : number;
  public selectedFacility: any;
  public selectedInvestigationTypeId: number;
  public selectedInspectionReasonId: number;
  public buttonName: string;
  public minDate: Date = new Date();
  public datepicker: Date;
  public bsValue: Date = new Date();
  public bsConfig: Partial<BsDatepickerConfig>;
  public inspectors: UserDto[] = [];
  public filteredPrimaryInspectors: UserDto[] = [];
  public filteredNonPrimaryInspectors: UserDto[] = [];
  public assignedUser: UserDto = null;
  public previousPrimaryInspector: UserDto = null;
  public assignedInspectorIDs: Array<number> = [];
  public currentInspectionType: string; 
  public currentInspectionName: string;
  public showFacilityType: boolean = false;
  public showInspectorsTab: boolean = true;
  public showPreviousInspection: boolean = false;
  public showInvestigationType: boolean = false;
  public investigationTypes: InvestigationType[] = [];
  public inspectionReasons: InspectionReason[] = [];

  constructor(private inspectionService: InspectionService, private spinner: NgxSpinnerService, private alertService: AlertService,
    private commonService: CommonService, private userService: UserService, private accountService: AccountService,
    private router: Router, private activatedRoute: ActivatedRoute, private errorHandlerService: ErrorHandlerService) {

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      }
      this.minDate.setDate(this.minDate.getDate());
      this.bsConfig = Object.assign({}, {dateInputFormat: 'MMMM Do YYYY', containerClass: 'theme-green' });
      this.currentInspectionType = this.activatedRoute.snapshot.params['inspectionTypeCode'];
      this.currentInspectionName = ITPS.codeToName(this.currentInspectionType);
     }

  ngOnInit() {
    this.commonService.getProductTypes().subscribe(resp => this.productTypes = resp);
    if([ITPS.POST_LICENSING_INSPECTION, ITPS.INVESTIGATION_INSPECTION, 
        ITPS.INFORMAL_MARKET_INSPECTION].indexOf(this.currentInspectionType) > -1){
      this.commonService.getFacilityTypes(true).subscribe(resp => this.facilityTypes = resp);
      this.showFacilityType = true;
      this.inspectionService.getInspectionReasons().subscribe(resp => this.inspectionReasons = resp);
    }

    if([ITPS.INVESTIGATION_INSPECTION, ITPS.INFORMAL_MARKET_INSPECTION].indexOf(this.currentInspectionType) > -1 || (this.accountService.isUserApplicant() && 
      this.currentInspectionType == ITPS.NEW_LOCAL_GMP_INSPECTION)){      
		  console.log("inside calling licencing component")
        this.showInspectorsTab = false;
        this.tabList = ['facility'];      
    } 

    this.showPreviousInspection = [ITPS.LOCAL_GMP_RENEWAL_INSPECTION].indexOf(
            this.currentInspectionType) > -1;

    if(this.currentInspectionType === ITPS.INVESTIGATION_INSPECTION){
      this.showInvestigationType = true;
      this.inspectionService.getInvestigationTypes().subscribe(resp => this.investigationTypes = resp);
    }
    
    this.tabIndex = 0;
    this.tab = this.tabList[this.tabIndex];
    this.setButtonName();
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  tabClicked(tab){
    this.tab = tab;
    this.tabIndex = this.tabList.findIndex(t => t === this.tab);
    this.setButtonName();
  }

  facilityTypeSelected(){
    if(this.selectedProductTypeId){
      this.getFacilitiesForInspection();
    }
  }

  productTypeSelected(){
    if(this.selectedFacilityTypeId || this.currentInspectionType !== ITPS.POST_LICENSING_INSPECTION){
      this.getFacilitiesForInspection();
    }
  }

  facilitySelected(){
    this.selectedFacility = this.facilities.find(m => m.id === this.selectedFacilityId);
    if(this.showInspectorsTab){
      this.fetchInspectors();
    }
  }

  getFacilitiesForInspection(){
    this.spinner.show();
    if(this.currentInspectionType == ITPS.POST_LICENSING_INSPECTION){
      this.inspectionService.getPostLicensingInspCandidateFacilities(this.selectedFacilityTypeId, this.selectedProductTypeId)
      .subscribe(resp => {
        this.facilities = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      });
    } else if(this.currentInspectionType == ITPS.NEW_LOCAL_GMP_INSPECTION){
      this.inspectionService.getNewLocalGMPInspCandidateFacilities(this.selectedProductTypeId).subscribe(resp => {
        this.facilities = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      });
    } else if(this.currentInspectionType == ITPS.LOCAL_GMP_RENEWAL_INSPECTION){
      this.inspectionService.getRenewalLocalGMPInspCandidateFacilities(this.selectedProductTypeId).subscribe(resp => {
        this.facilities = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      });
    } else if(this.currentInspectionType == ITPS.INVESTIGATION_INSPECTION){
      this.inspectionService.getInvestigationInspCandidateFacilities(this.selectedFacilityTypeId, this.selectedProductTypeId).subscribe(
        resp => {
        this.facilities = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      });
    } else if(this.currentInspectionType == ITPS.INFORMAL_MARKET_INSPECTION){
      this.inspectionService.getInformalMarketInspCandidateFacilities(this.selectedFacilityTypeId, this.selectedProductTypeId).subscribe(
        resp => {
        this.facilities = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.alertService.error(error.message);
        this.spinner.hide();
      });
    }
  }

  getDateString(inputDate) {
    let date = new Date(inputDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric'});
  }

  getApplicationNumber(selectedFacility) {
    return '0'.repeat(Math.max(5, selectedFacility.applicationID.toString().length) - selectedFacility.applicationID.toString().length) + selectedFacility.applicationID + 
        selectedFacility.applicationNumber
  }

  nextClicked(){
    if (this.tabIndex + 1 < this.tabList.length) {
      this.tabIndex++;
      this.tab = this.tabList[this.tabIndex];
      this.setButtonName();
    } else if (this.tabIndex + 1 === this.tabList.length) {
      this.submitClicked();
    }
  }

  setButtonName(){
    if (this.tabIndex == (this.tabList.length -1)) {
      this.buttonName = 'Submit';
    } else {
      this.buttonName = 'Next';
    }
  }

  getFacilityDepartment() {
    let facilityProductTypeName  = this.productTypes.find(p => p.name.trim() === this.selectedFacility.productTypeName.trim()).name;
    if (facilityProductTypeName === Constants.PRODUCT_TYPE_FOOD) {
      return Constants.FOOD_DEPARTMENT;
    } else if (facilityProductTypeName === Constants.PRODUCT_TYPE_TOBACCO) {
      return Constants.TOBACCO_DEPARTMENT;
    } else {
      return Constants.MED_DEPARTMENT;
    }
  }

  primaryInspectorChanged() {
    let index = this.filteredNonPrimaryInspectors.findIndex(u => u.id === this.assignedUser.id);
    this.filteredNonPrimaryInspectors.splice(index, 1);
    if (this.previousPrimaryInspector != null) {
      this.filteredNonPrimaryInspectors.push(this.previousPrimaryInspector);
    }
    this.filteredNonPrimaryInspectors = this.filteredNonPrimaryInspectors.slice(0); // ng-select only listens to changes if it is a new array

    this.filteredNonPrimaryInspectors.sort( (a, b) => {
      let name1 = a.fullName.toUpperCase();
      let name2 = b.fullName.toUpperCase();
      if (name1 < name2) {
        return -1;
      }
      if (name1 > name2) {
        return 1;
      }
      return 0;
    });

    this.previousPrimaryInspector = this.assignedUser;
    let primaryIndex = this.assignedInspectorIDs.findIndex(id => id === this.assignedUser.id);
    if (primaryIndex !== -1) {
      this.assignedInspectorIDs.splice(primaryIndex, 1);
      this.assignedInspectorIDs = this.assignedInspectorIDs.slice(0); // ng-select only listens to changes if it is a new array
    }
  }

  fetchInspectors(){
    this.userService.getInspectors(this.accountService.getUserBranchOffice().id).subscribe(resp => {
      this.inspectors = resp;
      this.inspectors.map( (user) => { user.fullName = user.firstName + ' ' + user.lastName; return user; } );
      const appDeptCode = this.getFacilityDepartment();
      this.filteredPrimaryInspectors = this.inspectors.filter(u => (u.departments.map(
        p => p.code).indexOf(appDeptCode) !== -1));
      this.filteredNonPrimaryInspectors = this.filteredPrimaryInspectors.slice(0);
    });
  }

  submitClicked(){
    this.spinner.show();

    let assignments: InspectionAssignment[] = [];
    if(this.showInspectorsTab){
      assignments.push(new InspectionAssignment(this.assignedUser.id, true, this.datepicker.toISOString()));
      this.assignedInspectorIDs.forEach(id => {
        assignments.push(new InspectionAssignment(id, false, this.datepicker.toISOString()));
      });   
    }
    let inspFacility: InspectionFacility[] = [];
    this.selectedFacility = this.facilities.find(m => m.id === this.selectedFacilityId);
    inspFacility.push(new InspectionFacility(this.selectedFacilityId, this.selectedFacility.applicationID));
    let inspection = new Inspection( assignments, inspFacility, []);
    inspection.previousInspectionID = this.selectedFacility.inspectionID;
    inspection.investigationTypeID = this.selectedInvestigationTypeId;
    inspection.reasonID = this.selectedInspectionReasonId;

    this.inspectionService.createInspection(inspection, this.currentInspectionType).subscribe(resp => {
      this.spinner.hide();
      if(resp){
        this.alertService.success(`The ${this.currentInspectionName} Inspection was Assigned Sucessfully!`);
        this.router.navigate(['/inspections/postLicensing/list/'+this.currentInspectionType]);
      }else {
        this.alertService.error(`Couldn't Assign the ${this.currentInspectionName} Inspection, please try again!`);
      }      
    }, error => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
      console.log(error);
    });
  }
}
